import server from "@/api/server";

async function getTeam(data) {
  let res = await server.post("agent/agent/subpartner/list", data);
  return res;
}

async function getLink() {
  let res = await server.get("agent/agent/subpartner/link");
  return res;
}

export { getTeam, getLink };
